export default {

    methods: {
        ajaxRequest( data, callbackSuccess, callbackNoSuccess ) {

            const ajaxurl = window.MODUL.ajaxurl

            return jQuery.post( ajaxurl, data, function(response){

                //console.log(response);

                if (response.success){
                    if (response.data){
                        callbackSuccess( JSON.parse( JSON.stringify(response.data) ) );
                    } else {
                        callbackSuccess( false );
                    }

                } else {
                    if (response.data){
                        callbackNoSuccess( JSON.parse( JSON.stringify(response.data) ) );
                    } else {
                        callbackNoSuccess( false );
                    }

                }
            });
        }
    }
}
